import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { IMessageLog, IMessageLogParam } from '../models/messageLog.model';
import qs from 'qs';

export const getMessageLogList = (param: IMessageLogParam): AxiosPromise<IMessageLog[]> => {
  const url = `/api/message-log?${qs.stringify(param)}`;
  return axios.get(url);
};
